export enum QueryParam {
  CardTransactionReference = 'cardTransactionReference',
  BanklinkTransactionReference = 'banklinkTransactionReference',
  Status = 'status',
  Brand = 'brand',
}

export enum PrepaymentSteps {
  PREPAID_DATA_STEP = 0,
  PRICE_STEP = 1,
  PAYMENT_STEP = 2,
}
